import React, { useCallback } from 'react';
import Modal from 'utils/packages/Modal';
import { Button, Spacer } from 'design-system';
import Text from 'design-system/Text';
import { useAppDispatch } from 'store/hooks';
import { setDeviceSettingsKey } from 'actions/deviceSettings';
import { isWeb } from '../../../constants';
const ModalContent = () => {
    const dispatch = useAppDispatch();
    const onDontShowAgain = useCallback(() => {
        dispatch(setDeviceSettingsKey('hideSpaceReminderModal', true));
        SpaceReminderModal.hide();
    }, []);
    return (<>
      <Spacer.H8 />
      <Text TextThin-14 Secondary centered={!isWeb}>
        Only the accounts that you have in this space will be visible in Feed.
        You can switch Spaces anytime using the icon in the top-right corner.
      </Text>
      <Spacer.H16 />
      <Button brandReversed title="Don’t show again" onPress={onDontShowAgain}/>
      <Spacer.H8 />
      <Button brand title="Okay" onPress={SpaceReminderModal.hide}/>
    </>);
};
export const SpaceReminderModal = {
    show: (space) => {
        Modal.show(<ModalContent />, {
            title: `You are in ${space.isDefault ? 'Private' : space.name} space`,
        });
    },
    hide: Modal.hide,
};
